import BaseDropifyForm from './BaseDropifyForm';

export default class DownloadablesForm extends BaseDropifyForm {

    constructor() {
        super('#downloadable_file');
    }
}